import { disposeMesh } from 'src/utils/object3DHelpers';
import { SceneComponent, Inputs, ComponentInteractionType } from './types';

export const videoButtonType = 'treedis.videoButton';

export class VideoButton extends SceneComponent {
  private root: any = null;

  private pivot: any = null;

  private button: any = null;

  private active = true;

  inputs: Inputs = {
    type: null,
    src: null,
    src2: null,
    size: 0.05,
    localPosition: null,
    localRotation: null
  };

  // setting which events are compatible with the component
  events = {
    [ComponentInteractionType.CLICK]: true,
    [ComponentInteractionType.HOVER]: true,
    [ComponentInteractionType.DRAG]: false
  };

  onInit() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();
    this.outputs.objectRoot = this.root;
    // setting the collider to allow events
    this.outputs.collider = this.root;
    this.root.add(this.pivot);

    // TODO: implement in other components
    this.root.name = videoButtonType;

    const { src, src2 } = this.inputs;
    this.makeBtn(this.active || !src2?.length ? src : src2);
  }

  onInputsUpdated() {
    const { localPosition, localRotation } = this.inputs;
    if (localPosition) {
      this.button.position.set(localPosition.x, localPosition.y, localPosition.z);
    }
    if (localRotation) {
      this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
    }
  }

  toggleActive() {
    const { src, src2 } = this.inputs;
    if (src2) {
      this.active = !this.active;
      this.makeBtn(this.active || !src2?.length ? src : src2);
    }
  }

  setActive(active: boolean) {
    const { src, src2 } = this.inputs;
    if (src2) {
      this.active = active;
      this.makeBtn(this.active || !src2?.length ? src : src2);
    }
  }

  isActive() {
    return this.active;
  }

  onDestroy() {
    if (this.button) {
      disposeMesh(this.button);
      this.button = null;
    }
  }

  private makeBtn(url: string | null) {
    if (this.button) {
      disposeMesh(this.button);
      this.button = null;
    }
    const THREE = this.context.three;
    const { size, localPosition, localRotation } = this.inputs;

    const geometry = new THREE.CircleGeometry(size, 128);
    // const _this = this;
    new THREE.TextureLoader().load(
      url,
      // onLoad callback
      (texture) => {
        try {
          if (texture.image.width == 0 || texture.image.width == 0) {
            throw new Error('Unable to get image resolution.');
          }
          texture.wrapS = THREE.RepeatWrapping;
          texture.wrapT = THREE.RepeatWrapping;
          texture.encoding = THREE.LinearEncoding;
          texture.repeat.set(1, 1);
          //texture.needsUpdate = true;
          if (texture.image.width == 0 || texture.image.height == 0) {
            //console.error('Unable to get image resolution.',texture);
            throw new Error('Unable to get image resolution.');
          }
          //_this.context.renderer.initTexture(texture);
          if (
            texture.image.width > this.context.renderer.capabilities.maxTextureSize ||
            texture.image.height > this.context.renderer.capabilities.maxTextureSize
          ) {
            texture.image.height =
              texture.image.height *
              (texture.image.height / this.context.renderer.capabilities.maxTextureSize);
            texture.image.width =
              texture.image.width *
              (texture.image.width / this.context.renderer.capabilities.maxTextureSize);
          }
          const material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            blending: THREE.NormalBlending,
            transparent: true,
            polygonOffset: true,
            polygonOffsetUnits: -4
            // color: 0x00FFCC,
          });
          this.button = new THREE.Mesh(geometry, material);
          this.pivot.add(this.button);

          if (localPosition) {
            this.button.position.set(localPosition.x, localPosition.y, localPosition.z);
          }
          if (localRotation) {
            this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
          }
        } catch (e) {
          console.log('[Err] An error happened during texture init.', e);
        }
      },
      // onProgress callback currently not supported
      undefined,
      // onError callback
      function (err) {
        console.error('[Err] An error happened during texture load.', err);
      }
    );
  }
}

export function makeVideoButton() {
  return new VideoButton();
}
